import { render } from "./userstagmenu.vue?vue&type=template&id=3d23c748"
import script from "./userstagmenu.vue?vue&type=script&lang=js"
export * from "./userstagmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__